import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HtmlRenderComponent } from './html-render.component';
import { PipesModule } from "../../../pipes/pipes.module";



@NgModule({
    declarations: [
        HtmlRenderComponent
    ],
    exports: [
        HtmlRenderComponent
    ],
    imports: [
        CommonModule,
        PipesModule
    ]
})
export class HtmlRenderModule { }
